<template>
  <div class="display_info">
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
        <displayInfoItem title="测试机构" more-path="/testInstitutions">
          <TestMechWheel/>
        </displayInfoItem>
      </el-col>
      <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
        <displayInfoItem title="考评员" more-path="/evaluationList">
          <CoachWheel/>
        </displayInfoItem>
      </el-col>
      <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
        <displayInfoItem title="运动员" more-path="/enquiry/certificateAuthenticity">
          <AthleteWheel/>
        </displayInfoItem>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import displayInfoItem from "@/views/admin/home/content/displayInfoItem.vue";
import TestMechWheel from "@/views/admin/home/swiper/testMechWheel.vue";
import CoachWheel from "@/views/admin/home/swiper/coachWheel.vue";
import AthleteWheel from "@/views/admin/home/swiper/athleteWheel.vue";

export default {
  name: "",
  components: {
    displayInfoItem,
    TestMechWheel,
    CoachWheel,
    AthleteWheel
  },
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>

.display_info {
  margin: 20px 0;
}
</style>
